<template>
  <div v-if="load && showContent">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <div v-if="showContent" @click="closeAllTips()">
      <v-data-table :headers="headers" :items="disciplines" :hide-default-footer="true" :items-per-page="-1">
        <template v-slot:item="{ item }">
          <tr>
            <td :discid="item.id">{{ item.name }}</td>
            <td class="text-center">
              <div v-if="item.grades">

                <v-tooltip v-model="grade.showTooltip" v-for="grade in item.grades" :open-on-hover="false"
                  :open-on-click="true" :close-on-content-click="true" location="top">
                  <template v-slot:activator="{ props }">
                    <span @click="closeAllTips(grade)" :gradeid="grade.id" :class="'cursor-pointer ' +
                      ($vuetify.display.mobile ? ' mr-3 ' : ' mr-1 ') +
                      gradeTypeColorMap[grade.type] ?? 'text-purple'" v-bind="props">
                      {{ grade.finalgrade }}
                    </span>
                  </template>
                  <span v-if="grade.type != 'attestat'">{{ grade.itemname }} {{ grade.date }}</span>
                  <span v-else>{{ grade.itemname }}</span>
                </v-tooltip>

              </div>
            </td>
            <td class="text-end">
              <span v-if="item.attendance && item.attendance.length" class="cursor-pointer">
                {{ item.attendance.length }}
                <v-tooltip activator="parent" location="top">
                  <p class="ma-0 pa-0" v-for="att in item.attendance">{{ att }}</p>
                </v-tooltip>
              </span>
            </td>
          </tr>
        </template>
        <template v-slot:bottom> </template>
      </v-data-table>
    </div>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-school"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Оценки</span>
      </v-col>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "gradeWidget",
  data() {
    return {
      disciplines: [],
      load: false,
      gradeTypeColorMap: {
        grade: "text-blue",
        quiz: "text-blue",
        finalgrade: "text-red",
        exam: "text-yellow",
        attestat: "text-yellow"
      },
      headers: [
        {
          title: "Дисциплина",
          align: "center",
          sortable: false,
        },
        {
          title: "Оценки",
          align: "center",
          sortable: false,
        },
        {
          title: "Пропуски",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && this.disciplines.length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/grades/getUserGrades"
        )
        .then((response) => {
          this.disciplines = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });
    },
    closeAllTips(excludeGrade) {
      this.disciplines.forEach((discipline) => {
        if (discipline.grades) {
          discipline.grades.forEach((element) => {
            if (excludeGrade !== element) {
              element.showTooltip = false;
            }
          });
        }
      });

    }
  },
};
</script>
<style lang="scss">
/*
#procollege_desktop2 {
  .pointer {
    cursor: pointer;
  }
}
*/
</style>
